import { TuiButtonModule } from '@taiga-ui/core';
import { TranslateModule } from '@ngx-translate/core';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

import { environment } from '@wo-environments';
import { FileHashPipe } from '@iss/wo-common/hash-files';

@Component({
  selector: 'wo-logout',
  templateUrl: './logout.component.html',
  styleUrls: [ './logout.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ TranslateModule, FileHashPipe, TuiButtonModule ],
})
export class LogoutComponent {
  public readonly appName = environment.appName;
  @Output() public readonly login = new EventEmitter<void>();
}
